var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.75V21.25C3 21.6642 3.33579 22 3.75 22C4.16421 22 4.5 21.6642 4.5 21.25V19H19.5V21.25C19.5 21.6642 19.8358 22 20.25 22C20.6642 22 21 21.6642 21 21.25V11.75H3ZM6 16.75C5.58579 16.75 5.25 16.4142 5.25 16V14C5.25 13.5858 5.58579 13.25 6 13.25C6.41421 13.25 6.75 13.5858 6.75 14V16C6.75 16.4142 6.41421 16.75 6 16.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2V10.25H9.84971C9.84689 10.2301 9.84284 10.2102 9.83751 10.1903L9.06105 7.29253C8.98958 7.0258 8.71541 6.86751 8.44868 6.93898L7.48275 7.1978C7.21602 7.26927 7.05773 7.54344 7.1292 7.81017L7.78295 10.25H6.84971C6.84689 10.2301 6.84284 10.2102 6.83751 10.1903L6.06105 7.29253C5.98958 7.0258 5.71541 6.86751 5.44868 6.93898L4.48275 7.1978C4.21602 7.26927 4.05773 7.54344 4.1292 7.81017L4.78295 10.25H3V4C3 2.89543 3.89543 2 5 2H11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.25V2H19C20.1046 2 21 2.89543 21 4V10.25H19.1838L19.8376 7.81017C19.9091 7.54344 19.7508 7.26927 19.484 7.1978L18.5181 6.93898C18.2514 6.86751 17.9772 7.0258 17.9057 7.29253L17.1293 10.1903C17.124 10.2102 17.1199 10.2301 17.1171 10.25H16.1838L16.8376 7.81017C16.9091 7.54344 16.7508 7.26927 16.484 7.1978L15.5181 6.93898C15.2514 6.86751 14.9772 7.0258 14.9057 7.29253L14.1293 10.1903C14.124 10.2102 14.1199 10.2301 14.1171 10.25H12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf1);
export default __webpack_public_path__ + "static/media/bookshelf-1.51f8c32154ad8581c687f50fb1f2c89c.svg";
export { ForwardRef as ReactComponent };